// extracted by mini-css-extract-plugin
export var label = "_f5-2";
export var slideContainer = "_f5-0";
export var slider = "_f5-1";